export const mqExtraSmall = "(min-width: 23.4375em)";
export const mqSmall = "(min-width: 48em)";
export const mqMedium = "(min-width: 64em)";
export const mqLarge = "(min-width: 83em)";
export const mqXlarge = "(min-width: 93.75em)";
export const mqSmallMobile = "(max-width: 23.375em)";
export const mqMobile = "(max-width: 47.9375em)";
export const mqMobileTablet = "(max-width: 63.9375em)";
export const mqTablet = "(min-width: 48em) and (max-width: 63.9375em)";
export const mqSmallDesktop = "(min-width: 64em) and (max-width: 82.9375em)";
export const mqFluidDesktop = "(min-width: 64em) and (max-width: 93.6875em)";
export const spacingXs = 4;
export const spacingS = 8;
export const spacingXm = 12;
export const spacingM = 16;
export const spacingL = 24;
export const spacingXl = 32;
export const spacing2Xl = 40;
export const spacing3Xl = 56;
export const spacing4Xl = 80;
export const spacing5Xl = 120;
export const spacingHeaderRoot = 56;
export const spacingHeaderMedium = 88;